import { Action, handleActions } from 'redux-actions';
import {
    TenantSelectedPayload,
    UserAuthenticatedPayload,
    tenantSelected,
    userAuthenticated,
} from '../action/authenticationEvents';
import { Tenant } from '../api/types';
import { TenantConfig } from '../tenants/config';
import { withLegacyTokenAliases } from '../common/legacyTokenAliases';
import { withMasterGrant } from '../common/masterGrant';

export interface AuthenticationState {
    config: TenantConfig | null;
    tenant: Tenant | null;
    permissions: string[];
    roles?: string[];
    permissionsLoaded: boolean;
}

export const initialState: AuthenticationState = {
    config: null,
    tenant: null,
    permissions: [],
    permissionsLoaded: false,
};

export const reducer = handleActions<AuthenticationState, any>(
    {
        [userAuthenticated.toString()]: (
            state = initialState,
            action: Action<UserAuthenticatedPayload>,
        ) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                // The one entry point for every permission source (DB role map,
                // Auth0 token): legacy tokens predate the per-element strings,
                // and master can do everything an Owner can.
                permissions: withMasterGrant(
                    withLegacyTokenAliases(action.payload.permissions ?? []),
                    action.payload.roles || [],
                ),
                roles: action.payload.roles || [],
                permissionsLoaded: true,
            };
        },
        [tenantSelected.toString()]: (
            state = initialState,
            action: Action<TenantSelectedPayload>,
        ) => {
            if (!state) {
                return state;
            }
            localStorage.setItem('selectedTenant', action.payload.tenant!);
            return {
                ...state,
                tenant: action.payload.tenant,
            };
        },
    },
    initialState,
);
